import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./common/axios-interceptor";
import { HelmetProvider } from 'react-helmet-async';
import { Contacts } from "./pages/contacts/contacts";
import { VerifyMail } from "./pages/email-verify/email-verify";
import { Announcements } from "./pages/announcements/announcements";
import { ReportGroup } from "./pages/reportGroup/reportGroup";
import { Error400 } from "./pages/errors/400";
import { Error404 } from "./pages/errors/404";
import { AppContacts } from "./pages/app-contacts/appContacts";
import { Survey } from "./pages/survey/survey";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Switch>
          <Route path="/contact.html" component={Contacts} />
          <Route path="/contacts" component={AppContacts} />
          <Route path="/sp/accounts/email/verify" component={VerifyMail} />
          <Route path="/sp/announcements/:id" component={Announcements} />
          <Route path="/sp/app/support/report/group" component={ReportGroup} />
          <Route path="/surveys/withdrawal" component={Survey} />
          <Route path="/errors/400" component={Error400} />
          <Route component={Error404} />
        </Switch>
      </Router>
    </HelmetProvider>
  );
}

export default App;
